import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';
export interface IUpdate1FormMeta {
  id: FormInputMeta,
  name: FormInputMeta,
  initials: FormInputMeta,
  type: FormInputMeta,
  bankGroup: FormInputMeta,
  country: FormInputMeta,

  // Schema
  schema: any,
}

const Update1FormMeta: IUpdate1FormMeta = {} as IUpdate1FormMeta

Update1FormMeta.id = {
  name: 'id',
  type: 'text',
  label: 'ID',
  placeholder: 'ID',
  validation: yup.string().required(),
};

Update1FormMeta.name = {
  name: 'name',
  type: 'text',
  label: 'Nom',
  placeholder: 'Nom',
  validation: yup.string().required(),
};

Update1FormMeta.initials = {
  name: 'initials',
  type: 'text',
  label: 'Initiales',
  placeholder: 'Initiales',
  validation: yup.string().required(),
};

Update1FormMeta.type = {
  name: 'type',
  type: 'text',
  label: 'Type',
  placeholder: 'Type',
  validation: yup.string().required(),
};

Update1FormMeta.bankGroup = {
  name: 'bankGroup',
  type: 'text',
  label: 'Groupe des Banques',
  placeholder: 'Groupe des Banques',
  validation: yup.string().required(),
};

Update1FormMeta.country = {
  name: 'country',
  type: 'text',
  label: 'Pays',
  placeholder: 'Pays',
  validation: yup.string().required(),
};

const validationSchema = getValidationSchema(Update1FormMeta)
Update1FormMeta.schema = yup.object().shape(validationSchema);

export default Update1FormMeta;